// src/services/taxService.js
import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const taxService = {

  
  getAll: async (filters = {}) => {
    try {
      const response = await apiClient.get(ENDPOINTS.TAX.GET_ALL, { params: filters });
      return response;
    } catch (error) {
      console.error('Failed to fetch tax:', error);
      throw error;
    }
  },

  
  getById: async (id) => {
    try {
      const response = await apiClient.get(ENDPOINTS.TAX.GET_BY_ID(id));
      return response;
    } catch (error) {
      console.error(`Failed to fetch tax ${id}:`, error);
      throw error;
    }
  },

  //  Create new tax
  create: async (data) => {
    try {
      const response = await apiClient.post(ENDPOINTS.TAX.CREATE, data);
      return response;
    } catch (error) {
      console.error('Failed to create tax:', error);
      throw error;
    }
  },

  //  Update payment account
  update: async (id, data) => {
    try {
      const response = await apiClient.put(ENDPOINTS.TAX.UPDATE(id), data);
      return response;
    } catch (error) {
      console.error(`Failed to update tax ${id}:`, error);
      throw error;
    }
  },

  //  Delete payment account
  delete: async (id) => {
    try {
      const response = await apiClient.delete(ENDPOINTS.TAX.DELETE(id));
      return response;
    } catch (error) {
      console.error(`Failed to delete tax ${id}:`, error);
      throw error;
    }
  },
};

export default taxService;
